import { currencyFormat } from '~/lib/i18n';

type Props = {
    mainTitle: string;
    subTitle: string;
    total: number;
    labels: string[];
    values: number[];
};

export const HouseholdBudgetSection: React.FC<Props> = ({ labels, mainTitle, subTitle, total, values }) => (
    <div className="flex flex-col gap-3 rounded-md bg-surface-light p-4 text-sm text-midnight">
        <p className="font-bold">{mainTitle}</p>
        {labels.map((label, index) => (
            <div className="flex justify-between gap-4 pl-4" key={label}>
                <span>{label}</span>
                <span>{currencyFormat(Number(values[index]))}</span>
            </div>
        ))}
        <div className="flex justify-between gap-4 font-bold">
            <span className="before:content-['=_']">{subTitle}</span>
            <span>{currencyFormat(Number(total))}</span>
        </div>
    </div>
);
